
export const counterActionType = Object.freeze({
    Increment: 'Counter_INCREMENT',
    Decrement: 'Counter_DECREMENT'
});
